import { render, staticRenderFns } from "./ed-radio.vue?vue&type=template&id=045d6fb9&scoped=true&"
import script from "./ed-radio.ts?vue&type=script&lang=ts&"
export * from "./ed-radio.ts?vue&type=script&lang=ts&"
import style0 from "./ed-radio.scss?vue&type=style&index=0&id=045d6fb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d6fb9",
  null
  
)

export default component.exports